import React, { useState } from 'react';
import { SearchIcon, FilterIcon, XIcon } from 'lucide-react';
import CommunityCard from '../components/CommunityCard';
const Search = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const mockCommunities = [{
    id: '1',
    name: 'WeRun Nairobi',
    description: 'A community of runners in Nairobi meeting every weekend for group runs and training.',
    memberCount: 358,
    location: 'Nairobi',
    category: 'Sports & Fitness',
    nextEvent: 'Saturday Run, 6AM',
    websiteUrl: 'https://werunnairobi.co.ke'
  }, {
    id: '2',
    name: 'Nairobi Tech Meetup',
    description: 'Monthly gatherings for tech enthusiasts to network and learn about the latest innovations.',
    memberCount: 425,
    location: 'Nairobi',
    category: 'Professional',
    nextEvent: 'Web3 Talk, Tue 6PM',
    websiteUrl: 'https://nairobimeetup.tech'
  }, {
    id: '3',
    name: 'Mombasa Beach Cleanup',
    description: 'Volunteers dedicated to keeping our beaches clean and preserving marine life.',
    memberCount: 189,
    location: 'Mombasa',
    category: 'Volunteering',
    websiteUrl: 'https://cleanbeachesmombasa.org'
  }];
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;
    setIsSearching(true);
    // Simulate search delay
    setTimeout(() => {
      const filtered = mockCommunities.filter(community => community.name.toLowerCase().includes(searchQuery.toLowerCase()) || community.description.toLowerCase().includes(searchQuery.toLowerCase()));
      setSearchResults(filtered);
      setIsSearching(false);
    }, 500);
  };
  const clearSearch = () => {
    setSearchQuery('');
    setSearchResults([]);
  };
  return <div className="p-4 pb-20" data-id="element-3176">
      <h1 className="text-2xl font-bold mb-4" data-id="element-3177">Search</h1>
      <form onSubmit={handleSearch} className="mb-4" data-id="element-3178">
        <div className="relative" data-id="element-3179">
          <input type="text" placeholder="Search communities, events, or interests..." className="w-full p-3 pl-10 pr-10 border border-gray-300 rounded-lg" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3180" />
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" data-id="element-3181" />
          {searchQuery && <button type="button" onClick={clearSearch} className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 rounded-full hover:bg-gray-100" data-id="element-3182">
              <XIcon className="w-5 h-5 text-gray-500" data-id="element-3183" />
            </button>}
        </div>
        <div className="flex mt-2" data-id="element-3184">
          <button type="submit" className="px-4 py-2 bg-gray-800 text-white rounded-md text-sm mr-2 flex-1" data-id="element-3185">
            Search
          </button>
          <button type="button" className="px-4 py-2 border border-gray-300 rounded-md text-sm flex items-center justify-center" data-id="element-3186">
            <FilterIcon className="w-4 h-4 mr-1" data-id="element-3187" />
            Filters
          </button>
        </div>
      </form>
      {isSearching ? <div className="flex justify-center items-center h-40" data-id="element-3188">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-800" data-id="element-3189"></div>
        </div> : searchResults.length > 0 ? <div data-id="element-3190">
          <p className="text-sm text-gray-500 mb-4" data-id="element-3191">
            Found {searchResults.length} results for "{searchQuery}"
          </p>
          <div className="space-y-4" data-id="element-3192">
            {searchResults.map(community => <CommunityCard key={community.id} {...community} data-id="element-3193" />)}
          </div>
        </div> : searchQuery ? <div className="text-center py-10" data-id="element-3194">
          <p className="text-gray-500" data-id="element-3195">No results found for "{searchQuery}"</p>
          <p className="text-sm text-gray-500 mt-1" data-id="element-3196">
            Try different keywords or browse categories
          </p>
        </div> : <div className="space-y-4" data-id="element-3197">
          <div className="border border-gray-300 rounded-lg p-4" data-id="element-3198">
            <h2 className="font-medium mb-2" data-id="element-3199">Popular Searches</h2>
            <div className="flex flex-wrap gap-2" data-id="element-3200">
              <button className="px-3 py-1 border border-gray-300 rounded-full text-sm hover:bg-gray-50" data-id="element-3201">
                Running Groups
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-full text-sm hover:bg-gray-50" data-id="element-3202">
                Tech Meetups
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-full text-sm hover:bg-gray-50" data-id="element-3203">
                Art Exhibitions
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-full text-sm hover:bg-gray-50" data-id="element-3204">
                Volunteer
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-full text-sm hover:bg-gray-50" data-id="element-3205">
                Weekend Events
              </button>
            </div>
          </div>
          <div className="border border-gray-300 rounded-lg p-4" data-id="element-3206">
            <h2 className="font-medium mb-2" data-id="element-3207">Recent Searches</h2>
            <p className="text-gray-500 text-sm" data-id="element-3208">
              Your recent searches will appear here
            </p>
          </div>
        </div>}
    </div>;
};
export default Search;